import React, { Component } from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import { change, Field, reduxForm } from "redux-form";
import classNames from "classnames";
import { reportValidateSubmit } from "validations/report.validate";
import { fetchReport } from "actions/report.action";
import { HELP_DOMAIN, JAVASCRIPT_VOID } from "constant/config";
import FormRadio from "components/forms/FormRadio";


class Report extends Component {
    state = {
        selectedReason: 0,
    };

    componentWillMount() {
        if (isMobile) {
            const { location } = this.props;
            const { state } = location;
            this.props.fetchReport(state.is_report_station);
        } else {
            const { data = {} } = this.props;
            this.props.fetchReport(data.is_report_station);
        }
    }

    handelChangeRadio = (e) => {
        const reason_info_no = parseInt(e.target.value, 10);
        this.props.dispatch(change(this.props.form, "report_info_no", reason_info_no));
        this.setState({ selectedReason: reason_info_no });
    };
    render() {
        const { t, handleSubmit, pristine, submitting, reportReducer } = this.props;
        const { reportReason } = reportReducer;
        if (isMobile) {
            const { location, history } = this.props;
            const { state } = location;
            return (
                <div id="bs-wrap" className="write">
                    <form onSubmit={handleSubmit}>
                        <Field name="common_idx" type="hidden" component="input" />
                        <Field name="board_type" type="hidden" component="input" />
                        <Field name="report_info_no" type="hidden" component="input" />
                        <Field name="mode" type="hidden" component="input" />
                        <header>
                            <section className="section">
                                <div className="grid-start">
                                    <button type="button" className="btn-back" onClick={() => history.goBack()}>
                                        <span>
                                            <Trans>뒤로가기</Trans>
                                        </span>
                                    </button>
                                </div>
                                <h2 className="title">
                                    <Trans>신고하기</Trans>
                                </h2>
                            </section>
                        </header>
                        <div id="bs-container">
                            <div id="bs-contents">
                                <article className="report_wrap">
                                    <div className="report_autor_info">
                                        <strong className="autor">
                                            <span>{state.writer_nick}</span>
                                            <em>({state.writer_id})</em>
                                        </strong>
                                        <p dangerouslySetInnerHTML={{__html: state.title}} />
                                    </div>

                                    <ul className="report_frm">
                                        {reportReason.map((reason) => (
                                            <li key={reason.report_info_no} className={classNames({ etc: reason.category === 1 })}>
                                                <p>
                                                    <label htmlFor={`rdo${reason.report_info_no}`}>{t(reason.comment)}</label>
                                                </p>
                                                <span className="radio">
                                                    <input
                                                        name="info_no"
                                                        type="radio"
                                                        id={`rdo${reason.report_info_no}`}
                                                        value={reason.report_info_no}
                                                        onChange={this.handelChangeRadio}
                                                    />
                                                    <i />
                                                </span>
                                                {reason.category === 1 && (
                                                    <div>
                                                        <Field
                                                            name="comment"
                                                            component="textarea"
                                                            placeholder={t("신고 사유를 입력해주세요.(300자 이내)")}
                                                            disabled={this.state.selectedReason !== parseInt(reason.report_info_no, 10)}
                                                        />
                                                    </div>
                                                )}
                                            </li>
                                        ))}
                                    </ul>

                                    <div className="report_info">
                                        <p>
                                            <Trans>
                                            불법촬영물등 유통 신고는 전기통신사업법제22조5조의 제1항 및 동법 시행령 제30조의5 제2항에따라 "신고인의 개인정보 수집, 이용 동의"와 "신고 사유 등에 대한 신고서 작성 후 제출"이 필요합니다.
                                            </Trans>
                                        </p>
                                        <a href = {`${HELP_DOMAIN}?type=exMailIllegal`} target = "_blank">
                                            <Trans>불법촬영물등 신고하기></Trans>
                                        </a>
                                    </div>

                                    <div className="btn-col-2">
                                        <span>
                                            <button type="button" className="cancel" onClick={() => history.goBack()}>
                                                <Trans>취소</Trans>
                                            </button>
                                        </span>
                                        <span>
                                            <button type="submit" className="submit" disabled={pristine || submitting}>
                                                <Trans>신고하기</Trans>
                                            </button>
                                        </span>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </form>
                </div>
            );
        } else {
            const { data = {} } = this.props;
            return (
                <div
                    className="ui-pop bs-report_layer"
                    onClick={(e) => {
                        e.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                    }}
                >
                    <form onSubmit={handleSubmit}>
                        <Field name="common_idx" type="hidden" component="input" />
                        <Field name="board_type" type="hidden" component="input" />
                        <Field name="report_info_no" type="hidden" component="input" />
                        <div className="pop-title">
                            <h3>
                                <Trans>신고하기</Trans>
                            </h3>
                        </div>
                        <div className="pop-body">
                            <div className="cont_text">
                                <p className="nick">
                                    {data.writer_nick} <span>({data.writer_id})</span>
                                </p>
                                <em dangerouslySetInnerHTML={{__html: data.title}} />
                            </div>
                            <div className="reason_list">
                                {reportReason.map((reason) => (
                                    <li key={reason.report_info_no}>
                                        <FormRadio
                                            name="info_no"
                                            id={`rdo${reason.report_info_no}`}
                                            value={reason.report_info_no}
                                            onChange={this.handelChangeRadio}
                                            label={t(reason.comment)}
                                        />
                                        {reason.category === 1 && (
                                            <Field
                                                name="comment"
                                                component="textarea"
                                                placeholder={t("신고 사유를 입력해주세요.(300자 이내)")}
                                                disabled={this.state.selectedReason !== parseInt(reason.report_info_no, 10)}
                                            />
                                        )}
                                    </li>
                                ))}
                            </div>
                            <p className="desc">
                                <Trans>
                                불법촬영물등 유통 신고는 전기통신사업법제22조5조의 제1항 및 동법 시행령 제30조의5 제2항에따라 "신고인의 개인정보 수집, 이용 동의"와 "신고 사유 등에 대한 신고서 작성 후 제출"이 필요합니다.
                                </Trans>
                            </p>
                            <a href = {`${HELP_DOMAIN}?type=exMailIllegal`} target = "_blank">
                                <Trans>불법촬영물등 신고하기></Trans>
                            </a>
                            <div className="btn-grid">
                                <div className="grid-end">
                                    <button type="submit" className="btn-basic blue" disabled={pristine || submitting}>
                                        <span>
                                            <Trans>신고</Trans>
                                        </span>
                                    </button>
                                    <button type="button" className="btn-basic" onClick={this.props.onClose}>
                                        <span>
                                            <Trans>취소</Trans>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <a href={JAVASCRIPT_VOID} className="pop-close" onClick={this.props.onClose}>
                            <span>
                                <Trans>닫기</Trans>
                            </span>
                        </a>
                    </form>
                </div>
            );
        }
    }
}

const ReportReduxForm = reduxForm({
    form: "report_form",
    onSubmit: reportValidateSubmit,
    enableReinitialize: true,
})(Report);

const mapStateToProps = (state, ownProps) => {
    return {
        reportReducer: state.reportReducer.toJS(),
        authenticationReducer: state.authenticationReducer,
        initialValues: {
            writer_id: ownProps.location ? ownProps.location.state.writer_id : ownProps.data.writer_id,
            common_idx: ownProps.location ? ownProps.location.state.common_idx : ownProps.data.common_idx,
            board_type: ownProps.location ? ownProps.location.state.board_type : ownProps.data.board_type,
            mode: ownProps.location ? "page" : "layer",
            is_report_station : (ownProps.location ? ownProps.location.state.is_report_station : ownProps.data.is_report_station) || false, 
        },
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchReport: (is_report_station) => {
            dispatch(fetchReport(is_report_station));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withTranslation()(ReportReduxForm));
